import React, { ChangeEventHandler, FocusEventHandler, useContext, useEffect, useState } from "react";
import * as Yup from "yup";
import { CreateArtifactContext } from "../../../../../context/CreateArtifactContext";
import { ContentState } from "../../../../../models/SKArtifact";

interface AddTextFieldProps {
  id?: string;
  name?: string;
  title?: string;
  note?: string;
  placeholder: string;
  index?: number;
  charAllowed: number;
  isCloseBtn?: boolean;
  value?: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onFocus?: FocusEventHandler<HTMLInputElement> | undefined;
  onBlur?: FocusEventHandler<HTMLInputElement> | undefined;
  onClose?: (index: number) => void;
  notesclass?: string;
  showRemainingChar?: boolean;
  disabled: boolean;
}

export const AddTextField = ({
  id,
  name,
  title,
  note,
  placeholder,
  charAllowed,
  onClose,
  index,
  value = "",
  onChange,
  onFocus,
  onBlur,
  notesclass = "notes-class-content",
  isCloseBtn = false,
  showRemainingChar = true,
  disabled = false,
}: AddTextFieldProps) => {
  // const { contentData, artifactId, updateContentData } = useContext(CreateArtifactContext);
  const [error, setError] = useState<string>("");
  // const [editable, setEditable] = useState<boolean>(true);

  // useEffect(() => {
  //   if (contentData.status === ContentState.DRAFT) {
  //     setEditable(true);
  //   } else {
  //     setEditable(false);
  //   }
  // }, [contentData]);

  const removeItem = () => {
    if (onClose && index !== undefined) {
      onClose(index);
    }
  };

  return (
    <>
      <div className="relative w-full min-w-[200px]">
        {title && (
          <div className="flex items-center">
            <span>{index && <span className="content_count">{index}</span>}</span>
            {name && <span className="content_title">{title}</span>}
          </div>
        )}
        {note && <div className={notesclass}>{note}</div>}
        <div className="flex input-class">
          <input
            type="text"
            name={name}
            id={name}
            className="input-text"
            placeholder={placeholder}
            required
            maxLength={charAllowed}
            value={value}
            onChange={onChange}
            disabled={disabled}
            onFocus={onFocus}
            onBlur={onBlur}
          />
          {isCloseBtn && !disabled && (
            <div className="content-center w-4 h-4 align-middle shadow-md top-1 rounded-3xl bg-slate-600 max-w-[486px] mr-[5px] mt-[5px]">
              <button
                id="removeItem"
                className="top-0 left-0 right-0 content-center w-4 h-4 text-white "
                onClick={e => {
                  e.stopPropagation();
                  removeItem();
                }}
              >
                ×
              </button>
            </div>
          )}
        </div>

        {error && <span className="remaining-characters">{error}</span>}

        {showRemainingChar === true && !error ? (
          <div className="remaining-characters">{charAllowed - (value.length ?? 0)} characters remaining.</div>
        ) : (
          ""
        )}
        {/* {!error && (
          <div className="remaining-characters">
            {charAllowed - (value.length ?? 0)} characters remaining.
          </div>
        )} */}
      </div>
    </>
  );
};
